<template>
  <app-panel title="Autres sessions">
    <ul class="divide-y">
      <li
        v-for="session in sessions"
        :key="session.id"
        class="py-4 first:pt-0 last:pb-0"
        :data-cy-other-session-id="session.id"
      >
        <course-page-other-session :course="course" :session="session" />
      </li>
    </ul>
  </app-panel>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import CoursePageOtherSession from "~/pages/courses/[slug]/_includes/components/course-page-other-session.vue";

defineProps<{
  course: CoursePageView;
  sessions: CourseSessionView[];
}>();
</script>
